
export function number_format(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
